
import _ from 'lodash'
import '../../../css/svdreact.css'
import Terrain from '../../terrain/Terrain'
import CardTerrain from '../../terrain/CardTerrain'

import GlassTerrain from '../../terrain/GlassTerrain'
import TerrainAmenitiesTablet from '../../terrain/TerraainAmenitiesTablet'
import TerrainAmenities from '../../terrain/TerrainAmenities'
import TerrainHighlights from '../../terrain/TerrainHighlights'
import TerrainLocation from '../../terrain/TerrainLocation'
import TerrainGallery from '../../terrain/TerrainGallery'
import TerrainReview from '../../terrain/TerrainReview'
import TerrainStars from '../../terrain/TerrainStars'
import {Icon, Avatar} from 'antd'
import ErrorCom from '../../core/AbodeErrorTag'
import SVAbodeSpinner from '../../core/SVAbodeSpinner';
import moment from 'moment'
import SJCarousel from "../../../views/SJCarousel";
import SJCarouselDyna from "../../../views/SJCarouselDyna";

import {SV_SOJ_ORCMOCK_ADDRESS,SV_SOJ_NOTCAROUSEL_VIEW} from '../../../constants'
import InvBoardTable from './invBoardTable'
import InvDetAmenity from './InvDetAmenity'
import InvDetPoi from './InvDetPoi'
import InvDetAbout from './InvDetAbout'

import InvDetBus from './InvDetBus'
import InvDetEnt from './InvDetEnt' 
//import InvDetMeal from './InvDetMeal'
import InvDetSport from './InvDetSport' 
import InvDetHealth from './InvDetHealth'
import InvDetFacility from './InvDetFacility'
import history from "../../../history"

import { sjpriceAndTexNow } from '../../../redux/svractions/shreviewActions'
import InvDetMeal from './InvDetMeal'

   const React = require('react')

   const {connect}  = require("react-redux")
   const {Link} = require("react-router")
   const HBD_URL = 'http://photos.hotelbeds.com/giata/'
   
  
class InvTerrainContainer extends React.Component {
  
    constructor(props) {
        super(props)
        let me = this
        this.invofferselectparent = this.invofferselectparent.bind(this)
        this.getAppDetails = this.getAppDetails.bind(this)
        this.getAppDetailsUseCookie = this.getAppDetailsUseCookie.bind(this)
        
        this.getMyHtml = this.getMyHtml.bind(this)
        this.svsojourns = []
        this.title = 'PROD-NON-PROD Symmetry'
        this.getCarouselOrPhoto = this.getCarouselOrPhoto.bind(me)
        this.getHotelDetailBodyContainer_soj = this.getHotelDetailBodyContainer_soj.bind(me)
        this.getChildContainers = this.getChildContainers.bind(me)
        this.getInvdetContainer = this.getInvdetContainer.bind(me)
        this.getInvpoiContainer = this.getInvpoiContainer.bind(me)
        this.getInvaboutContainer = this.getInvaboutContainer.bind(me)
        this.getInvtableContainer = this.getInvtableContainer.bind(me)

        this.getInvbusContainer = this.getInvbusContainer.bind(me)
        this.getInventContainer = this.getInventContainer.bind(me)

        this.getInvmealContainer = this.getInvmealContainer.bind(me)
        this.getInvsportContainer = this.getInvsportContainer.bind(me)

        this.getInvhealthContainer = this.getInvhealthContainer.bind(me)
        this.getInvfacilitytContainer = this.getInvfacilitytContainer.bind(me)
        //getInvtableContainer
        
        
        //getInvpoiContainer
    }

    getInvtableContainer(soj){
        let plot  = 'RESULT'
        let o = soj
        const {invofferselectparent} = this
        let customerId = -1
        let svcustProfile = {
            "customerId": -6,
            "addressId":-1
        }
        let priceInfo = {
            o:o,
            customerId:customerId
        }
        return( 
            
                     <InvBoardTable invofferselectparent={invofferselectparent}  priceInfo={priceInfo} svcustProfile={svcustProfile} plot={plot} data={soj} />  
           )
    }
    getInvaboutContainer(soj){
         const {invofferselectparent} = this
        return( 
            <InvDetAbout invofferselectparent={invofferselectparent} data={soj}></InvDetAbout>
           )
    }
    getInvpoiContainer(soj){
        return( 
            <InvDetPoi data={soj}></InvDetPoi>
           )
    }
    getInvdetContainer(soj, fgtree){
        return( 
            <InvDetAmenity data={soj} fgtree={fgtree}></InvDetAmenity>
           )
    }
    //jul13 start
    getInvbusContainer( fgtree){
        return( 
            <InvDetBus  fgtree={fgtree}></InvDetBus>
           )
    }
    getInventContainer( fgtree){
        return( 
            <InvDetEnt  fgtree={fgtree}></InvDetEnt>
           )
    }

    getInvmealContainer( fgtree){
        return( 
            <InvDetMeal  fgtree={fgtree}></InvDetMeal>
           )
    }
    getInvsportContainer( fgtree){
        return( 
            <InvDetSport fgtree={fgtree}></InvDetSport>
           )
    }

    getInvhealthContainer( fgtree){
        return( 
            <InvDetHealth  fgtree={fgtree}></InvDetHealth>
           )
    }
    getInvfacilitytContainer(fgtree){
        return( 
            <InvDetFacility  fgtree={fgtree}></InvDetFacility>
           )
    }
    //jul13 end

    getAppDetails(paramQSpaceId){
        console.log('id detail spacekey**noCookie missing price Reatekey************', paramQSpaceId)
        //this.props.sojDetailsAndImagesSV(paramQ) 
        let paramOb = {
            paramQSpaceId:paramQSpaceId,
            ratekey: "",
            code:paramQSpaceId,
            reviews:null,
            room: null
        }
       // this.props.svwithImagesWrappedfetchTaskActionCreator(paramQ);
       this.props.sojAndImagesSojournPaginate1HotelById(paramOb);
        /*this.props.getSojournDetails("mancreek") */
       
    }
    getAppDetailsUseCookie(paramQSpaceObWithId){
        let paramQSpaceId = paramQSpaceObWithId.id
        console.log('id detail spacekey**************', paramQSpaceId)
        //this.props.sojDetailsAndImagesSV(paramQ) 
       // this.props.svwithImagesWrappedfetchTaskActionCreator(paramQ);
       const { cookies } = this.props;
        let sjcookob =  cookies.get('sjcook')

       // let sjcookob  = JSON.parse(sjcook_s)
        let roomob = sjcookob.room ? sjcookob : { "code":"FBF", "name":" Double BR"}
       // let rateKey = sjcookob.ratekey
       // roomob.ratekey
        let paramOb = {
            paramQSpaceId:paramQSpaceId,
            ratekey: roomob.ratekey,
            code:sjcookob.code,
            reviews:sjcookob.reviews,
            room: roomob
        }
        console.log('id detail spacekey and rates using sjcook****jul14**********', paramOb)
        console.log('id detail this.props.myloc***jul14**********', this.props.myloc)
    /*
{ my_esqueryText: "San Diego", STARTDATE: "2025-08-14", ENDDATE: "2025-08-15", time_zone: "+01:00" }
    */
let sv_esquery_data = {
    my_esqueryText: "San Diego", 
    STARTDATE: "2025-08-14",
     ENDDATE: "2025-08-15",
      time_zone: "+01:00"
}
if(this.props.myloc && this.props.myloc.STARTDATE){
     sv_esquery_data = this.props.myloc
}
       

      this.props.sojAndImagesSojournPaginate1HotelById(paramOb, sv_esquery_data);
        /*this.props.getSojournDetails("mancreek") */
       
    }
    componentWillMount()	{
        console.log('sv--task=--- link sends us params')
        console.log(this.props.params)
         //console.log(this.props.params.id)
         let id;
         if(this.props.svparams){
            id = this.props.svparams
         
         }else{
          console.log('not called by router')
          id = 1;
         }
        
    console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
    
    
     /*   this.state = {
          tasks: svtasks[0]
        }
    */
        
       // this.getAppDetails(id)
        this.getAppDetailsUseCookie(id)
       // this.props.sojAndImagesSojournPaginate1HotelById(paramOb);
       
        //this.props.svwithImagesWrappedfetchTaskActionCreator(id);
    /*this.props.svWrappedfetchTaskActionCreator(id); */
/*
		console.log('=---json')
		let svsojourns = [
        
            {
                "name": "3",
                "id": 3,
                "selected": false,
                "age": 32,
                "species": "Stego"
            },
            {
                "name": "4",
                "id": 4,
                "selected": false,
                "age": 13,
                "species": "T. Rex"
            }
        ]
        console.log('**sv sohourns got from service ********')
		console.log(svsojourns)
		
//sv step1 dipatch action  dispatch is warpper with actiobcreateer by redux
//sv step2 reduce gives you new state that is available as props to render method
    			console.log('sv--tasks')
    			this.svsojourns = svsojourns
    			var ar = svsojourns;
			//this.props.svWrappedfetchSVESSearchActionCreator(ar)
            this.getAppDetails('mancreek')
            */
			
			
	

	}

     getMyHtml(){
        let ar = this.state.my_data;
        
        console.log(this.state)
        console.log(ar);
        const my_data = this.state.my_data;
        return my_data.map(o => {
            console.log(o)
            return (<li>{o.name}</li>)
        });
    }

/*
    getChildContainersOld() {
        const legend = [{
            "sojourncode": "100",
            "vernacularcode": "EN",
            "sojourn_name": "253 Mancreek Resort"
        },
        {
            "sojourncode": "101",
            "vernacularcode": "EN",
            "sojourn_name": "253 John Resort"
        }]
        let data = [], hosts = [], dbs = [], sojourns = [], my_data = []
        if (this.props.data && (this.props.data.length > 0)) {
            data = this.props.data
        }
       
        if (this.props.my_data && (this.props.my_data.length > 0)) {
            my_data = this.props.my_data
        }
       
        return (
            <div>

  <a target="_blank" rel="noopener noreferrer" href="https://www.booking.com/hotel/us/san-diego-del-mar.html?label=gen173nr-1FCAEoggI46AdIM1gEaIkCiAEBmAExuAEYyAEP2AEB6AEB-AECiAIBqAIEuAKNu_CxBsACAdICJGY4NTJhN2NkLTkxMmItNDE1Zi04ZGI4LTVjYWRjNDU2N2M3NNgCBeACAQ&amp;aid=304142&amp;ucfs=1&amp;arphpl=1&amp;checkin=2024-05-24&amp;checkout=2024-06-07&amp;dest_id=20015725&amp;dest_type=city&amp;group_adults=2&amp;req_adults=2&amp;no_rooms=1&amp;group_children=0&amp;req_children=0&amp;hpos=1&amp;hapos=1&amp;sr_order=popularity&amp;srpvid=025e05dca08401b2&amp;srepoch=1715217706&amp;all_sr_blocks=26285401_246425381_0_42_0&amp;highlighted_blocks=26285401_246425381_0_42_0&amp;matching_block_id=26285401_246425381_0_42_0&amp;sr_pri_blocks=26285401_246425381_0_42_0__250600&amp;from_sustainable_property_sr=1&amp;from=searchresults&amp;map=1" class="a83ed08757 f88a5204c2 a1ae279108 b98133fb50"><span><span class="aee5343fdb def9bc142a" data-testid="address">Carmel Valley, San Diego</span><span class="aee5343fdb def9bc142a">Show on map</span></span></a><span class="aee5343fdb"><span class="f419a93f12"><span aria-expanded="false" data-testid="distance">16.1 miles from downtown</span></span></span><span class="aee5343fdb"><span class="f419a93f12"><span aria-expanded="false">Beach Nearby</span></span></span>
  
                {

                     my_data.map(o => {
                        console.log(o)
                        return (<li>{_.join(o.amenity_name) }</li>)
                    })
                }
            </div>
           
            
            )
    }
*/

    getChildContainers(){
        /*   <TerrainLocation  svrlocation={svr_location}></TerrainLocation> */
        let soj = null, data = [], hosts = [], dbs = [], sojourns = [], my_data = [], fgtree = []
        
        let svrstars = {
            "sv_rating_no": 5,
            "color": "#e8a01899"
        }
        let svr_tablets = []
        console.log('SJUL14***** this.props')
        console.log(this.props)
        console.log('SJUL14***** this.props END')
        //let svr_tablets = ["http://localhost:8080/images/soj2.jpg", "http://localhost:8080/images/soj3.jpg", "http://localhost:8080/images/soj4.jpg", "http://localhost:8080/images/soj5.jpg", "http://localhost:8080/images/soj6.jpg" ]
        if (this.props.sojourDetailView.my_data && (this.props.sojourDetailView.my_data.length > 0)) {
            my_data = this.props.sojourDetailView.my_data
            soj = my_data[0]
        }
        if (this.props.sojourDetailView.fgtree ) {
            fgtree = this.props.sojourDetailView.fgtree
           
        }
        if (this.props.sojourDetailView.svr_soj_detail_images_ob && (this.props.sojourDetailView.svr_soj_detail_images_ob.gallery.length > 0)) {
            svr_tablets = this.props.sojourDetailView.svr_soj_detail_images_ob.gallery
            console.log('sv***Nov18***sojourDetailView Gallery***** START')
            console.log(svr_tablets)
            console.log('sv***Nov18***sojourDetailView Gallery***** END')
            
           
        }
        soj = soj ? soj : {}
        let amenities =  soj['amenity_name']?  soj['amenity_name'] : []
        let highlights =  soj['highlights']?  soj['highlights'] : 'ante, venenatis non adipiscing vitae'
        let svr_location = {
            "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
            "resort_name": soj['sojourn_name'] ? soj['sojourn_name'] : "253 Mancreek Resort" ,
            "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
            "county": soj['county'] ? soj['county'] : "albanyt",
            "postalcode":soj['postal_code'] ? soj['postal_code'] : 12193,
            "market_code":soj['marketcode'] ? soj['marketcode'] :  "NAMER",
            "country": soj['country_name'] ? soj['country_name'] : "usa",
           "nearest_airport_distance_mi_lvl": soj['nearest_airport_distance_mi_lvl']?  soj['nearest_airport_distance_mi_lvl'][0]: 3,
           "en_nearest_airports_lvl": soj['en_nearest_airports_lvl']?  soj['en_nearest_airports_lvl'][0]: 3,
            
           "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
           "state":soj['state'] ? soj['state'] : "NY"

        }
        let svrreview = {
           
            "num_reviews":soj['num_reviews'] ? soj['num_reviews'] : 10,
            "num_reviews_text": "reviews",
            "sv_rating": (soj.sv_rating ? soj.sv_rating : "Excellent") ,
            "sv_rating_no":(soj.avg_stars_rating ? soj.avg_stars_rating : 5) 
        }
        let svr_location_old = {
            "space_key": soj['space_key'] ? soj['space_key'] : "203@4@F@10@10@20251124@7@Y@EVR",
            "resort_name": soj['resort_name'] ? soj['resort_name'] : "253 Mancreek Resort" ,
            "address_line1": soj['address_line1'] ? soj['address_line1'] : " 253 scottland av",
            "county": soj['county'] ? soj['county'] : "albanyt",
            "postalcode":soj['postalcode'] ? soj['postalcode'] : 12193,
            "market_code":soj['market_code'] ? soj['market_code'] :  "NAMER",
            "country": soj['country'] ? soj['country'] : "usa",
           
            "state":soj['state'] ? soj['state'] : "NY",
        }
    
        let im1 = null, im2 =null, im3 = null, im4 = null, im5 = null
        if(soj.hotel && soj.hotel.images){
            im1 = HBD_URL +  soj.hotel.images[0].path 
            im2 = HBD_URL +  soj.hotel.images[1].path 
            im3 = HBD_URL +  soj.hotel.images[2].path 
            im4 = HBD_URL +  soj.hotel.images[3].path 
            im5 = HBD_URL +  soj.hotel.images[4].path 

            
        }else{
            im1 = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`
            im2 = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj2.jpg`
            im3 = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj3.jpg`
            im4 = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj4.jpg`
            im5 = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj5.jpg`
        }
        let reservekey = 'insvreview'
        let plot  = 'RESULT'
        const lastestUpdateDate = 'Data Refresh Daily'
        return ( <div style={{"height":"300px"}} className="svr-det-pageWrapper">
        <header className="svr-header1">
            <h1> Sojourn View Detail</h1>
        </header>
        
        <TerrainLocation reservekey={reservekey}  svrlocation={svr_location}></TerrainLocation>
       
      
       
            
       
    <div  className="svr-gal-contentWrapper" >
        <article className="main-detail-full">
                {/*  
             <div className="rev-row ">
                    <InvBoardTable plot={plot} data={soj} />   
             </div>
             */}
            <div>
                 <div>

                
                        <div className="rev-row ">
                                    <div className="col-md-6">
                                    <CardTerrain lastestUpdateDate={lastestUpdateDate}  body={this.getInvdetContainer(soj, fgtree)}></CardTerrain>
                                    </div>
                                    <div className="col-md-6">
                                    <CardTerrain lastestUpdateDate={lastestUpdateDate}  body={this.getInvpoiContainer(soj)}></CardTerrain>
                                    </div>
                        </div>
                        <div className="rev-row ">
                                    <div className="col-md-12">
                                        <CardTerrain lastestUpdateDate={lastestUpdateDate}  body={this.getInvaboutContainer(soj)}></CardTerrain>
                                    </div>
                        </div>
                        <div className="rev-row ">
                                    <div className="col-md-6">
                                    <CardTerrain lastestUpdateDate={lastestUpdateDate}  body={this.getInvbusContainer(fgtree)}></CardTerrain>
                                    </div>
                                    <div className="col-md-6">
                                    <CardTerrain lastestUpdateDate={lastestUpdateDate}  body={this.getInventContainer(fgtree)}></CardTerrain>
                                    </div>
                        </div>
                        <div className="rev-row ">
                                    <div className="col-md-6">
                                    <CardTerrain lastestUpdateDate={lastestUpdateDate}  body={this.getInvsportContainer(fgtree)}></CardTerrain>
                                     </div>
                                    <div className="col-md-6">
                                    <CardTerrain lastestUpdateDate={lastestUpdateDate}  body={this.getInvfacilitytContainer(fgtree)}></CardTerrain>
                                    </div>
                        </div>

                        <div className="rev-row ">
                                    <div className="col-md-6">
                                    <CardTerrain lastestUpdateDate={lastestUpdateDate}  body={this.getInvmealContainer(fgtree)}></CardTerrain>
                                    </div>
                                    <div className="col-md-6">
                                    <CardTerrain lastestUpdateDate={lastestUpdateDate}  body={this.getInvhealthContainer(fgtree)}></CardTerrain>
                                   
                                    </div>
                        </div>
                        

                        <div className="rev-row ">
                                    <div className="col-md-12">
                                        <CardTerrain lastestUpdateDate={lastestUpdateDate}  body={this.getInvtableContainer(soj)}></CardTerrain>
                                    </div>
                        </div>
            </div>
        </div>
        </article>
        <article className="main">
        <div className="row">
                        <div className="svr-sojlist-boxr-1">
                              
                               
                              
                              
                           </div>
        </div>
        <div className="svr-gal-box-row1">


            <div className="svr-gal-boxl-2">
                <div className="gallery">
                    <figure>
                        <img src={`${im2}`} alt="Carpet Grass" />

                    </figure>
                    <figure>
                        <img src={`${im3}`} alt="Bentgrass" />

                    </figure>


                </div>
            </div>

            <div className="svr-gal-boxr-1">
                <div className="gallery">
                    <figure>
                        <img src={`${im1 }`} alt="Carpet Grass" />

                    </figure>

                </div>
            </div>


        </div>
        <TerrainGallery  tablets={svr_tablets}></TerrainGallery>
       
     


    </article>

        
         
        
       
        </div>

        
            
       
{/*  
<TerrainAmenities  amenities={amenities}></TerrainAmenities>
*/}
{/* 

 <TerrainAmenitiesTablet  border="1px solid rgb(204, 230, 213)" backgroundColor="#baf7f4" amenities={amenities}></TerrainAmenitiesTablet>

 <br/>
            <div className="svr-reserve-main" >
    
                
    
               
                <div className="svr-highlight-content">
                    <aside className="sidebar-reserve resources">
    
                   
                   
                        <h3> Resources</h3>
                        <ul>
                          <li><a href="report.pdf">Annual Report</a></li>
                          <li><a href="template.doc">Corporate Word Temp</a></li>
                          <li><a href="logos.zip">Corporate Graphics</a></li>
                          <li><a href="http://www.yahoo.com/">Parent Corporate Site</a></li>
                          <li><a href="http://www.yahoo.com/">More Links</a></li>
                        </ul>
                      
                </aside>
                <TerrainHighlights highlights={highlights} ></TerrainHighlights>
                   
    
    
    
                </div>
                
               
    
                
            </div>

      
     */}
           
    
            <footer>
                <p>Copyright 2013, SV Greek Text Generator, Inc.</p>
                <p>Contact <a href="mailto:nobody@nowhere.com"> w-mail@xx.com</a> </p>
            </footer>
        </div>
        
        )

    }

    


    getHotelDetailBodyContainer_soj(my_data ){
        const lastestUpdateDate = 'Data Refresh Daily'
        if(this.props.error && (this.props.error === true) ){
            console.log('sv**container ger errob')
            let errob = {
                "timestamp": "2015-08-23T02:27:18.038+0000",
                "status": 500,
                "error": "FlyServer Error",
                "message": "No Resulst Found.Please refinse search and try again",
                "path": "/kk/svaddressDetailPost"
            }
            let today_dt = new Date()
            errob["timestamp"] = today_dt
           return (
             <div >
                
                 <div style={{paddingTop:'10px'}}>
                   <ErrorCom  closecbParent={this.closecbParent} errob={errob} ></ErrorCom>
                 </div>
                
                
              </div>   
                )
    
          }else if(this.props.loading && (this.props.loading === true) ){
           return (
    
             <div >
                <h3>Spinner*****</h3>
             <div style={{paddingTop:'10px'}}>
            
    
               <SVAbodeSpinner />
             </div>
            
            
          </div>   
    
           
                 )
    
          }
        /*
          if (this.props.loading) {
    return <Loader type='spinner' />
    } else if (this.props.error) {
    return <ErrorWidget error={this.props.error} />
    }
    */
    return (
             
           
             
                       
                      
        <GlassTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainers()}></GlassTerrain>
                       
    )
    }


    getCarouselOrPhoto = (o) =>{
        let ar =  o['imgs']
       let roomImgs =ar
       let roomImg = `${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`
       if(roomImgs && (roomImgs.length > 0)) {
            roomImg = roomImgs[0]
       }

       let photoOnly =  SV_SOJ_NOTCAROUSEL_VIEW ? SV_SOJ_NOTCAROUSEL_VIEW :false
       
       if(photoOnly){
                     return  (
                 <div className="gallery">
                     <figure style={{'marginBottom':'0px'}}>
                     <span  >	<Link to={`/svessearch/svredsojourn/${o.space_key}`}> 
                     
                     <img src={`${roomImg}`}  alt="Carpet Grass" />
                     </Link> </span>
                         
                     </figure>
                 </div>)

       }
       //check ar
       if(ar && (ar.length > 2) ){
           let roomImgs = ar.slice(0,6)
         return ( <SJCarouselDyna roomImgs={roomImgs} ></SJCarouselDyna>)

       }else{
           return ( <SJCarousel ></SJCarousel>)
       }

   }
    render() {
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title} = this

       /*to do we donot neeed care - terrain is card . just planin textstyel images page to hsow terrrain  */
        
       console.log('svrender', this.props)
       const {my_data} = this.props

          return (

            
            <div className="col-md-12">
                {
                    this.getHotelDetailBodyContainer_soj(my_data)
                }
                 
                
            </div>
        )
        
    }

    /*sjjul16 start*/
    invofferselectparent(valuesChild,oroomselected_orate ){
        let me = this
      console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^sv  OCT28  1 cookie1 from AmbLocation callback  flyboard svofferselectparent**********parent')
      console.log(valuesChild)
      let spaceKey = valuesChild['spacekey']
     
      const { cookies } = this.props;
      console.log('sv*** MARCH27SV localStorage start')
      console.log(cookies)
      console.log('sv*** MARCH27SV localStorage end')
    
     /*
      const { cookies , localStorage} = this.props;
     console.log('sv*** MARCH27SV localStorage start')
     console.log(localStorage)
     console.log('sv*** MARCH27SV localStorage end')
*/
      if(cookies){
          let sjcookoffer_o = null
          console.log('********OCT25**************** sv  OCT28 2 COOKIES SET sjcookoffer START')
  
          if(valuesChild ){
                console.log('********NOV19**************** sv START ')
            let sjcookoffer_val = {}
            
              
              let svcustProfile_newcustomer = {
                "customerId": -6,
                "addressId":-1
            }
            //room selection is first room . UI screen for roomtype selection needed
            let svvc = {}
            console.log('sjjul13 oroomselected_orate', oroomselected_orate)
            let assetCode = (  oroomselected_orate && oroomselected_orate.assetCode) ?   oroomselected_orate.assetCode  : "DBL.KG-1"
            console.log('sjjul13 assetCode', assetCode)
            let assetSelected = _.find(valuesChild.assets, function(sp){
                // console.log('facob_one find start', hid) 
                 //console.log(sp)
                 //console.log('facob_one find start', hid) 
                 if( (sp["code"] == assetCode) ){
                     return true
                 }else{
                     return false
                 }
                 // return sp['code'] === hid
             })

             let asset = assetSelected ? assetSelected : valuesChild.assets[0]
            let obroom = {
                "code":asset.code,
                "name":asset.name,
                rates: []
            }
            
             let rateNow = (oroomselected_orate &&  oroomselected_orate.orate  )?  oroomselected_orate.orate :  asset.rates[0]
             obroom.rates.push(rateNow)
             let ratekey = rateNow.rateKey 
             svvc.rateKey = ratekey
             svvc.code = valuesChild['spacekey']
             svvc.reviews =valuesChild['reviews']
             svvc.room = obroom
             svvc.svrate= rateNow
             console.log('user selected JULY16** rateNow', rateNow)
             console.log('svvc**may25', svvc)
             svvc.svcustProfile = svcustProfile_newcustomer
             if(!valuesChild['svcustProfile']){
                valuesChild['svcustProfile'] = svcustProfile_newcustomer
             }
/*
            
             let svaluesChild = JSON.stringify(valuesChild)
             */
             let svaluesChild = JSON.stringify(svvc)
             let size = svaluesChild.length
             console.log('********OCT25**************** SIZE OF  COOKIES  svcookoffer ', size)
  
             /*svnov20 start*/
             //we need to save in db based on sessionid or jwttoken genereate
             //and get that
             /*
             let toffer = valuesChild
             if(toffer && toffer["travelerPricings"] && toffer["travelerPricings"] ){
                 let tars = toffer["travelerPricings"]
                 for(let m=0; m <  tars.length; m++){
                     delete tars[m].fareDetailsBySegment
                 }
             }
             */
            /*svnov20 start*/
             
              

            
              try{
                  /*
                console.log(localStorage)
                localStorage.setItem('svcookls', svaluesChild);
                cookies.set('svcook', svaluesChild, { path: '/' });
                */
                cookies.set('sjcook', svaluesChild, { path: '/' });

              }catch(error){
                console.log('********Nov29****************  COOKIES ERROR UNABLE TO SAVE  sjcookoffer START')
   
                   console.log(error)}
             

              let m_offer = cookies.get('sjcook')
              console.log('********OCT25**************** TEST TO COOKIES SET sjcookoffer START', m_offer)
              /*svdec2 start */
              let my_data_sjtoffee ={
                "customerId": valuesChild['svcustProfile']['customerId'] ,
                "svt": "ba53a90c9b1d3d7906af5a561b926cc7",
                "sjcook": "{\"season\":\"GREEN\",\"sojourncode\":\"100\",\"vernacularcode\":\"EN\"}"
            } 
            my_data_sjtoffee.sjcook = svaluesChild
            console.log('********DEC4**************** expresseion sesion START ')
            /*
            save to redis
            this.props.saveUserOffer({'my_data_svtoffee' :my_data_svtoffee})
             

            */
            let expsessid_svt_s =  cookies.get('svabodeclientguest')
            console.log(expsessid_svt_s);
            
            let m_svt = expsessid_svt_s
            if(m_svt != null){
                my_data_sjtoffee['svt'] = m_svt
            }
            console.log('********DEC4**************** TEST TO COOKIES SET my_data_sjtoffee ')
            console.log(my_data_sjtoffee)
            console.log('********DEC4**************** expresseion sesion START ')
            
            // this.props.saveUserOffer({'my_data_sjtoffee' :my_data_sjtoffee})
             
            /*svdec2 end*/
              
           
            const udob ={
                "svcid": -2,
                "soj_rate_key":oroomselected_orate.orate.rateKey,
                "code": valuesChild["spacekey"] ,
                "room": obroom
                
            
            }

          
            _.delay(()=>{
                /*
                console.log('sv****calling delauy DEC3 START'  )
                const { soj_rate_key} = udob
                let surl = `/myaccountSV/${svcid}/shressvCustNew/${soj_rate_key}`
                console.log(surl)
                console.log('sv****calling delauy May26 end' )
                 history.push(`/myaccountSV/${svcid}/shressvCustNew/${soj_rate_key}`)
       
                */
                 console.log('sv****calling delauy DEC3 START'  )
                 const { soj_rate_key} = udob
                 const { code} = udob
                 let surl = `/inetsojourn/shredbook/${code}`
               // let surl = `/inetsojourn/shredfly/${code}`
                console.log(surl)
                console.log('sv****calling delauy DEC3 END' )
               history.push(`/inetsojourn/shredbook/${code}`)


                //history.push(`/inetsojourn/shredfly/${code}`)
               
               /*svamy26mon  passing id and spaceKey to ShyReserveWithSearchPage wich calls SJReview*/
                   }, 400, udob);

            // history.push(`/inetsojourn/shredfly/${soj_rate_key}`)
  
          }else{
              console.log('********OCT25**************** FAILED TO COOKIES SET sjcookoffer START')
   
          }
          

      }
    
    }
    /*sjjul16 end*/
}
/*
InvTerrainContainer = connect((state) => {
    return {
        loading: state.pnpReducer.loading,
        hosts: state.pnpReducer.pnp_host_data,
        dbs: state.pnpReducer.pnp_db_data,
        lastUpdate: state.pnpReducer.pnp_update,
        error: state.pnpReducer.error
    }
}, {

    })(InvTerrainContainer)
*/
export default InvTerrainContainer